import api from "../../../shared/api/client";

/** GET /api/audit — paginated audit rows. */
export async function getAuditLog(filters = {}) {
  const { data } = await api.get("/audit", { params: filters });
  return data;
}

/** GET /api/audit/meta — filter options (entities, users, actions). */
export async function getAuditMeta() {
  const { data } = await api.get("/audit/meta");
  return data;
}
